import React from 'react';
import { WarningFilled } from '@tag/tag-icons';

import Button, { ButtonStyleType } from '@/components/common/Button/Button';
import { theme } from '@ui/theme';
import AgModalWindow, { IAgModalWindowProps } from './AgModalWindow';
import ActionButtonsWrapper from './ActionButtonsWrapper/ActionButtonsWrapper';
import styles from './confirmation-modal.module.scss';

export interface IAgConfirmationModalProps extends Exclude<IAgModalWindowProps, 'headerIcon | borderAccent'> {
  onConfirm: () => void;
  isConfirmButtonDisabled?: boolean;
  closeText?: string;
  confirmText?: string;
  closeOnConfirm?: boolean // if we don`t want to call onClose after onConfirm
}

export default function AgConfirmationModal(props: IAgConfirmationModalProps) {
  const {
    children,
    closeText = 'Cancel',
    confirmText = 'Confirm',
    onClose,
    onConfirm,
    closeOnConfirm = true,
    isConfirmButtonDisabled,
    ...restProps
  } = props;

  return (
    <AgModalWindow
      headerIcon={(
        <div className={styles['warning-icon']}>
          <WarningFilled size="32" />
        </div>
      )}
      onClose={onClose}
      borderAccent={theme.palette.secondary}
      {...restProps}
    >
      <div className={styles.content}>
        {children}
      </div>

      <ActionButtonsWrapper
        showDivider={false}
        leftButton={(
          <Button
            buttonStyleType={ButtonStyleType.SECONDARY}
            onClick={() => {
              onClose();
            }}
          >
            {closeText}
          </Button>
        )}
        rightButton={(
          <Button
            disabled={isConfirmButtonDisabled}
            type="submit"
            buttonStyleType={ButtonStyleType.PRIMARY}
            onClick={() => {
              onConfirm();
              if (closeOnConfirm) onClose();
            }}
          >
            {confirmText}
          </Button>
        )}
      />
    </AgModalWindow>
  );
}
